import { render, staticRenderFns } from "./AppButtonCloseEditFailure.vue?vue&type=template&id=008ea72a&scoped=true&"
import script from "./AppButtonCloseEditFailure.vue?vue&type=script&lang=ts&"
export * from "./AppButtonCloseEditFailure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ea72a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
